/**
 * IMPORTS
 */
import AxiosService from "@/infra/http/axios";
import { ICustumersRepository } from "@/interface/custumers";

const customersRepository: ICustumersRepository = {
  /**
   * Função para buscar clientes
   * @param accessToken
   * @returns Promise<any | null>
   */
  async getAllCustomers<T>(
    accessToken: string,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.get(
      `users?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return customers?.data;
  },

  /**
   * Função que buscar todos usuário de um cliente
   * @param accessToken
   * @param user_cliente_id
   * @param currentPage
   * @param itemsPerPage
   * @param searchItem
   * @returns
   */
  async buscarUsuariosPorCliente<T>(
    accessToken: string,
    user_cliente_id = 0,
    currentPage: number = 1,
    itemsPerPage: number = 10,
    searchItem = ""
  ): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const usuariosCliente = await Instance.get(
      `usuarios-cliente/cliente/${user_cliente_id}?page=${currentPage}&per_page=${itemsPerPage}&search=${searchItem}`,
      {
        headers: {
          "content-type": "application/json; charset=UTF-8",
          accept: "*/*",
        },
      }
    );

    return usuariosCliente?.data;
  },

  /**
   * Função que busca um usuário
   * @param accessToken
   * @param user_id
   * @returns
   */
  async buscarPorUsuario<T>(accessToken: string, user_id = 0): Promise<T | null> {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const usuario = await Instance.get(`users/${user_id}`, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return usuario?.data;
  },

  async criarNovoUsuario(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`users`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async criarUsuariosCliente(accessToken, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const customers = await Instance.post(`usuarios-cliente`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return customers?.data;
  },

  async atualizarUsuario(accessToken, user_id, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const clienteAtualizado = await Instance.put(`users/${user_id}`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return clienteAtualizado?.data;
  },

  async atualizarUsuarioCliente(accessToken, user_id, payload) {
    const Instance = await AxiosService.createAxiosInstance(accessToken);

    const usuarioCliente = await Instance.put(`usuarios-cliente/${user_id}`, payload, {
      headers: {
        "content-type": "application/json; charset=UTF-8",
        accept: "*/*",
      },
    });

    return usuarioCliente?.data;
  },
};

/**
 * EXPORTS
 */
export { customersRepository };
